export default __webpack_public_path__ + "static/media/pencilicon.be13800d.svg";